const set = require('regenerate')(0x61F, 0x640, 0x204F, 0x2E41);
set.addRange(0x1E900, 0x1E94B).addRange(0x1E950, 0x1E959).addRange(0x1E95E, 0x1E95F);
exports.characters = set;
